import { useTranslation } from "react-i18next";
import { Modal } from "semantic-ui-react";

import { ReactTable } from "components";

import type { AccessorColumnDef } from "@tanstack/react-table";
import type { Device, DeviceHistory } from "models";

type DeviceUserHistoryModalProps = {
  device: Device | null;
  onClose: () => void;
};

export const DeviceUserHistoryModal = ({ device, onClose }: DeviceUserHistoryModalProps) => {
  const { t } = useTranslation();

  const columns: AccessorColumnDef<DeviceHistory>[] = [
    {
      id: "full_name",
      accessorFn: row => row,
      header: () => <span className="no-wrap-text">{t("v8_name", "Name")}</span>,
      cell: ({ row: { original } }) => original.full_name
    },
    {
      id: "dealer_name",
      accessorFn: row => row,
      header: () => <span className="no-wrap-text">{t("v8_dealer", "Dealer")}</span>,
      cell: ({ row: { original } }) => original.dealer_name
    },
    {
      id: "location_name",
      accessorFn: row => row,
      header: () => <span className="no-wrap-text">{t("v8_location", "Location")}</span>,
      cell: ({ row: { original } }) => original.location_name
    },
    {
      id: "role_name",
      accessorFn: row => row,
      header: () => <span className="no-wrap-text">{t("v8_role", "Role")}</span>,
      cell: ({ row: { original } }) => original.role_name
    }
  ];

  return (
    <Modal open={!!device} onClose={onClose} size="large" closeIcon>
      <Modal.Header>{t("v8_tablet_user", "Tablet User")}</Modal.Header>
      <Modal.Content scrolling>
        <div className="DeviceUserHistoryModal">
          <ReactTable
            columns={columns}
            data={device?.user_history}
            emptyRowMessage={t("v8_no_records_found_in_user_history_for_this_device", "No records found in user history for this device.")}
          />
        </div>
      </Modal.Content>
    </Modal>
  );
};
